import { useState } from 'react';
import { api } from '../api';
import type { Chapter } from '../types';

export function Admin({
  chapters,
  onChange,
}: {
  chapters: Chapter[];
  onChange: () => void;
}) {
  const [busy, setBusy] = useState(false);

  const create = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    setBusy(true);
    try {
      await api.createChapter({
        number: Number(fd.get('number')),
        title: String(fd.get('title')),
        summary: String(fd.get('summary') ?? ''),
      });
      e.currentTarget.reset();
      onChange();
    } catch (err) {
      alert((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <h2>Admin</h2>
      <p className="muted">
        Set the admin token in the sidebar (matches the worker secret{' '}
        <code>ADMIN_TOKEN</code>) before mutating data.
      </p>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Add chapter</h3>
        <form onSubmit={create} className="col">
          <input
            name="number"
            type="number"
            placeholder="Chapter number"
            required
          />
          <input name="title" placeholder="Chapter title" required />
          <textarea name="summary" placeholder="One-line summary" />
          <div>
            <button className="btn" disabled={busy}>
              {busy ? 'Saving…' : 'Add'}
            </button>
          </div>
        </form>
      </div>

      <div className="card">
        <h3 style={{ marginTop: 0 }}>Existing chapters</h3>
        {chapters.map((c) => (
          <div key={c.id} className="reading-row">
            <div>
              <strong>Ch.{c.number}</strong> — {c.title}
              {c.summary && <div className="muted">{c.summary}</div>}
            </div>
            <button
              className="btn danger"
              onClick={async () => {
                if (
                  !confirm(
                    `Delete Ch.${c.number} "${c.title}" and all its readings/notes?`,
                  )
                )
                  return;
                await api.deleteChapter(c.id);
                onChange();
              }}
            >
              Delete
            </button>
          </div>
        ))}
        {!chapters.length && <div className="muted">No chapters.</div>}
      </div>
    </div>
  );
}
